import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ListItemSeparator } from '@/components/list-item';
import { ListSection, RecyclerList } from '@/components/recycler-list';
import {
  PAYMENT_LINK_DETAIL_LIST_ITEM_HEIGHT,
  PaymentLinkDetailItemOption,
  PaymentLinkDetailListItem,
  PaymentLinkDetailListItemFields,
} from './payment-link-detail-list-item';
import { ScrollViewProps, View } from 'react-native';

interface Props {
  currencyCode: string | null;
  scrollViewProps?: ScrollViewProps;
  sections: ListSection<PaymentLinkDetailItemOption>[];
  setSelectedListItem: (
    paymentLinkLineItem: PaymentLinkDetailListItemFields,
  ) => void;
}

export const PaymentLinkDetailList: React.FC<Props> = ({
  currencyCode,
  scrollViewProps,
  sections,
  setSelectedListItem,
}) => {
  const [styles] = useStyles();

  return (
    <RecyclerList
      estimatedItemSize={PAYMENT_LINK_DETAIL_LIST_ITEM_HEIGHT}
      ItemSeparatorComponent={() => (
        <ListItemSeparator style={styles.listItemSeparator} />
      )}
      renderItem={({ item, index }) => {
        return (
          <>
            {index === 0 ? <View style={styles.listHeader} /> : null}
            <PaymentLinkDetailListItem
              currencyCode={currencyCode}
              option={item}
              setSelectedListItem={setSelectedListItem}
            />
          </>
        );
      }}
      sections={sections}
      {...scrollViewProps}
    />
  );
};

const useStyles = createStyles((theme) => ({
  listHeader: {
    height: 16,
  },
  listItemSeparator: {
    backgroundColor: theme.sk.color.divider.default,
  },
}));
